import { useContext, useMemo } from 'react'
import { useParams, Navigate } from 'react-router-dom'

import { AppContext } from '/providers/app-context'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/template-editor'
import Menu from '/components/templates/template-nav-menu'

import Editor from '/components/editor/index'

const TemplateEditor = () => {

  const { templateId } = useParams()
  const { loadingTemplates, templates } = useContext(AppContext)

  const template = useMemo(() => templates.filter(t => t.template_id === templateId)[0], [templates, templateId])

  if (!loadingTemplates && !template) return <Navigate to="/templates" replace />

  const heading = useMemo(() => template ? `${template.name} ${template.archived ? " [archived]" : ""}` : "",[template])

  return (
    <PageWrapper title="Template Editor" HelpText={HelpText} showWait heading={heading} menu={<Menu template={template} />}>
      <Editor />
    </PageWrapper>
  )
}

export default TemplateEditor
